import type { EntitySection } from '@/lib/entity-sections';

/*
 * Domain knowledge: the sub-sections an agent/broker detail view exposes. Lives
 * in the feature (EntitySectionLayout and lib/entity-sections are domain-free).
 * Ported verbatim from the prototype's `ENTITY_SECTIONS['agents-brokers']`
 * (public/js/entity-sub-menu.js) so existing deep links keep working; `profile`
 * is the first section and the fallback.
 */
export const agentBrokerSections: readonly EntitySection[] = [
  { id: 'profile', label: 'Profile' },
  { id: 'licenses', label: 'Licenses' },
  { id: 'commissions', label: 'Commissions' },
  { id: 'contracts', label: 'Contracts' },
  { id: 'bank-accounts', label: 'Bank Accounts' },
];
